/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 *
 * @export
 * @interface HistoricalBookingDebitReconciliationRequest
 */
export interface HistoricalBookingDebitReconciliationRequest {
    /**
     *
     * @type {string}
     * @memberof HistoricalBookingDebitReconciliationRequest
     */
    userId: string;
    /**
     *
     * @type {CurrencyAmount}
     * @memberof HistoricalBookingDebitReconciliationRequest
     */
    targetDebit: CurrencyAmount;
    /**
     *
     * @type {string}
     * @memberof HistoricalBookingDebitReconciliationRequest
     */
    expectedState: HistoricalBookingDebitReconciliationRequestExpectedStateEnum;
    /**
     *
     * @type {string}
     * @memberof HistoricalBookingDebitReconciliationRequest
     */
    auditDigest: string;
    /**
     *
     * @type {string}
     * @memberof HistoricalBookingDebitReconciliationRequest
     */
    evidenceDigest: string;
    /**
     *
     * @type {boolean}
     * @memberof HistoricalBookingDebitReconciliationRequest
     */
    allowNegativeBalance: boolean;
    /**
     *
     * @type {string}
     * @memberof HistoricalBookingDebitReconciliationRequest
     */
    policyVersion: HistoricalBookingDebitReconciliationRequestPolicyVersionEnum;
}


/**
 * @export
 */
export const HistoricalBookingDebitReconciliationRequestExpectedStateEnum = {
    Missing: 'missing',
    Zero: 'zero',
    Exact: 'exact'
} as const;
export type HistoricalBookingDebitReconciliationRequestExpectedStateEnum = typeof HistoricalBookingDebitReconciliationRequestExpectedStateEnum[keyof typeof HistoricalBookingDebitReconciliationRequestExpectedStateEnum];

/**
 * @export
 */
export const HistoricalBookingDebitReconciliationRequestPolicyVersionEnum = {
    HistoricalDebitReconciliationV1: 'historical_debit_reconciliation_v1'
} as const;
export type HistoricalBookingDebitReconciliationRequestPolicyVersionEnum = typeof HistoricalBookingDebitReconciliationRequestPolicyVersionEnum[keyof typeof HistoricalBookingDebitReconciliationRequestPolicyVersionEnum];


/**
 * Check if a given object implements the HistoricalBookingDebitReconciliationRequest interface.
 */
export function instanceOfHistoricalBookingDebitReconciliationRequest(value: object): value is HistoricalBookingDebitReconciliationRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('targetDebit' in value) || value['targetDebit'] === undefined) return false;
    if (!('expectedState' in value) || value['expectedState'] === undefined) return false;
    if (!('auditDigest' in value) || value['auditDigest'] === undefined) return false;
    if (!('evidenceDigest' in value) || value['evidenceDigest'] === undefined) return false;
    if (!('allowNegativeBalance' in value) || value['allowNegativeBalance'] === undefined) return false;
    if (!('policyVersion' in value) || value['policyVersion'] === undefined) return false;
    return true;
}

export function HistoricalBookingDebitReconciliationRequestFromJSON(json: any): HistoricalBookingDebitReconciliationRequest {
    return HistoricalBookingDebitReconciliationRequestFromJSONTyped(json, false);
}

export function HistoricalBookingDebitReconciliationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoricalBookingDebitReconciliationRequest {
    if (json == null) {
        return json;
    }
    return {

        'userId': json['user_id'],
        'targetDebit': CurrencyAmountFromJSON(json['target_debit']),
        'expectedState': json['expected_state'],
        'auditDigest': json['audit_digest'],
        'evidenceDigest': json['evidence_digest'],
        'allowNegativeBalance': json['allow_negative_balance'],
        'policyVersion': json['policy_version'],
    };
}

export function HistoricalBookingDebitReconciliationRequestToJSON(json: any): HistoricalBookingDebitReconciliationRequest {
    return HistoricalBookingDebitReconciliationRequestToJSONTyped(json, false);
}

export function HistoricalBookingDebitReconciliationRequestToJSONTyped(value?: HistoricalBookingDebitReconciliationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'user_id': value['userId'],
        'target_debit': CurrencyAmountToJSON(value['targetDebit']),
        'expected_state': value['expectedState'],
        'audit_digest': value['auditDigest'],
        'evidence_digest': value['evidenceDigest'],
        'allow_negative_balance': value['allowNegativeBalance'],
        'policy_version': value['policyVersion'],
    };
}

